import React from 'react';
// Components
import CbSettingsComponent from 'components/common/CbSettingsComponent/CbSettingsComponent';

const CbSettings = (): JSX.Element => {
  return <CbSettingsComponent />;
};

export default CbSettings;
